import { DefaultService } from '@/services/DefaultService';

export default class FinanceiroService extends DefaultService {
  constructor(http, router, env) {
    super(http, router, env);
  }

  loadFinanceiro(idCliente){
    return this._http.get(encodeURI(`${this._env}/ven/cliente/financeiro.json?idcliente=${idCliente}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problema ao realizar função loadFinanceiro em FinanceiroService');
    });
  }

  loadPrazosPgto(idCliente) {
    return this._http.get(encodeURI(`${this._env}/ven/cliente/financeiro/loadprazospgto.json?idcliente=${idCliente}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problema ao realizar função loadPrazosPgto em FinanceiroService');
    });
  }

  loadFormasPgto(idCliente) {
    return this._http.get(encodeURI(`${this._env}/ven/cliente/financeiro/loadformaspgto.json?idcliente=${idCliente}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problema ao realizar função loadFormasPgto em FinanceiroService');
    });
  }

  loadTabPreco(idCliente) {
    return this._http.get(encodeURI(`${this._env}/ven/cliente/financeiro/loadtabpreco.json?idcliente=${idCliente}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problema ao realizar função loadTabPreco em FinanceiroService');
    });
  }

  saveVendas(financeiro){
    return this._http.post(`${this._env}/ven/cliente/financeiro`, financeiro, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problema ao realizar função save em FinanceiroService');
    });
  }

  saveAgro(financeiro){
    return this._http.post(`${this._env}/agro/cliente/financeiro`, financeiro, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problema ao realizar função save em FinanceiroService');
    });
  }
}